import { Component, Input, OnInit } from "@angular/core";

import { FooterComponent } from '@coreui/angular';

@Component({
  selector: 'app-base-layout-footer',
  templateUrl: './base-layout-footer.component.html',
})
export class BaseLayoutFooterComponent extends FooterComponent implements OnInit {
  @Input() unitName: string;
  @Input() orgLink: string;
  public currentDate: Date;

  constructor() {

    super();

    this.currentDate = new Date();
  }

  ngOnInit(): void {

  }

}
